import * as React from "react";
import { SVGProps } from "react";
export const NoticeboardIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.02128 8.9178C6.81813 8.9178 6.62331 8.9985 6.47966 9.14214C6.33602 9.28579 6.25532 9.48062 6.25532 9.68376C6.25532 9.88691 6.33602 10.0818 6.47966 10.2253C6.6233 10.369 6.81813 10.4497 7.02128 10.4497H12.9787C13.1819 10.4497 13.3767 10.369 13.5203 10.2253C13.664 10.0818 13.7447 9.8869 13.7447 9.68376C13.7447 9.48062 13.664 9.28579 13.5203 9.14214C13.3767 8.9985 13.1819 8.9178 12.9787 8.9178H7.02128Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.17021 11.471C5.96706 11.471 5.77225 11.5517 5.6286 11.6954C5.48495 11.8389 5.40426 12.0338 5.40426 12.237C5.40426 12.4401 5.48495 12.6349 5.6286 12.7785C5.77224 12.9222 5.96706 13.0029 6.17021 13.0029H13.8298C14.0329 13.0029 14.2277 12.9222 14.3714 12.7785C14.5151 12.6349 14.5957 12.4401 14.5957 12.237C14.5957 12.0338 14.5151 11.8389 14.3714 11.6954C14.2277 11.5517 14.0329 11.471 13.8298 11.471H6.17021Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.02128 14.0242C6.81813 14.0242 6.62331 14.1049 6.47966 14.2486C6.33602 14.3921 6.25532 14.587 6.25532 14.7902C6.25532 14.9932 6.33602 15.1881 6.47966 15.3317C6.6233 15.4754 6.81813 15.5561 7.02128 15.5561H12.9787C13.1819 15.5561 13.3767 15.4754 13.5203 15.3317C13.664 15.1881 13.7447 14.9932 13.7447 14.7902C13.7447 14.587 13.664 14.3921 13.5203 14.2486C13.3767 14.1049 13.1819 14.0242 12.9787 14.0242H7.02128Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.8085 6.36461H15.7926C15.7557 6.29051 15.707 6.2226 15.6483 6.16389L12.3471 2.86257C11.7246 2.24034 10.8805 1.89078 10.0004 1.89078C9.12031 1.89078 8.27622 2.24034 7.65379 2.86257L4.35163 6.16304C4.29266 6.222 4.2438 6.29011 4.20687 6.36461H3.19149C2.87548 6.36461 2.57243 6.49014 2.34898 6.71359C2.12553 6.93703 2 7.2401 2 7.5561V16.9178C2 17.2338 2.12553 17.5368 2.34898 17.7603C2.57243 17.9837 2.87548 18.1092 3.19149 18.1092H16.8085C17.1245 18.1092 17.4276 17.9837 17.651 17.7603C17.8745 17.5368 18 17.2338 18 16.9178V7.5561C18 7.2401 17.8745 6.93703 17.651 6.71359C17.4276 6.49014 17.1245 6.36461 16.8085 6.36461ZM11.2639 3.94572L13.6822 6.36461H6.31781L8.73607 3.94572C8.90203 3.77971 9.09907 3.64802 9.31594 3.55817C9.53281 3.46833 9.76525 3.42208 10 3.42208C10.2347 3.42208 10.4671 3.46833 10.6841 3.55817C10.9009 3.64802 11.098 3.77971 11.2639 3.94572ZM16.4681 16.5773H3.53192V7.89652H16.4681V16.5773Z"
            fill="currentColor"
        />
    </svg>
);
NoticeboardIcon.displayName = "NoticeboardIcon";
